import { Button } from '@coolblue-development/freddy';
import SendIcon from '../../../../../../assets/send.svg';

interface SendButtonProps {
  onClick: () => void;
  isLoading?: boolean;
  disabled?: boolean;
}

export const SendButton = ({ onClick, isLoading, disabled }: SendButtonProps): JSX.Element => {
  return (
    <Button
      data-testid="send-button"
      endIcon={<SendIcon />}
      variant="primary"
      onClick={onClick}
      loading={isLoading}
      disabled={isLoading || disabled}
    />
  );
};
